import { checkElementInView } from "../__utils/checkElementInView";

const animationSelectors = 'body.page-template-tpl-donor-page .page-content > *, .block-timeline, .block-chart';
const sections = document.querySelectorAll(animationSelectors);

const showSection = (e) => {
    e.classList.add('in-viewport');
};

const hideSection = (e) => {
    e.classList.remove('in-viewport');
};

const sectionsInView = () => {
    if (sections.length) {
        checkElementInView(animationSelectors, showSection, hideSection, {
            root: null,
            rootMargin: "0px 0px -20% 0px",
            threshold: [0],
        });
    }
};

export default sectionsInView;